<template>
    <li class="gh-breadcrumb__item">
        <span v-if="isText" class="gh-breadcrumb__item__inner">
            <span class="gh-breadcrumb__item__inner">
                <slot></slot>
            </span>
        </span>
        <span v-else class="gh-breadcrumb__item__inner">
            <router-link v-if="notTheLast" :to="to">
                <slot></slot>
            </router-link>
            <span v-else class="gh-breadcrumb__item__inner">
                <slot></slot>
            </span>
        </span>
        <span class="gh-breadcrumb__separator" v-if="notTheLast">{{ separator }}</span>
    </li>
</template>

<script>
    export default {
        name: 'gh-breadcrumb-item',

        props: {
            to: {
                type: String
            },

            isLast: {
                type: Boolean,
                default: false
            },

            isText: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            separator() {
                return this.$parent.separator || '|';
            },

            notTheLast() {
                return ! this.isLast;
            }
        }
    }
</script>